import { createSelector } from 'redux-starter-kit';

export default {
  selected: createSelector(['projects.selected']),
  list: createSelector(['projects.list']),
};
